// extracted by mini-css-extract-plugin
export default {"nav":"Cabecalho_nav__cFcN4","esquerdaLinks":"Cabecalho_esquerdaLinks__CoslF","direitaLinks":"Cabecalho_direitaLinks__UHM0c","menuLinks":"Cabecalho_menuLinks__tsL7N"};